import React from 'react';
import { Button } from './ui/Button';
import { Phone } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center bg-fixed bg-cover bg-center" style={{
    backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/akEDJQV9eXufDvhzCqQFAJ/689c152cdf61c204da6ae5bd.webp")'
  }} data-id="element-124">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/70" data-id="element-125"></div>

      {/* Subtle floating light particle animation (CSS simulation) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-126">
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-[var(--brand-gold)] rounded-full mix-blend-screen filter blur-[100px] opacity-30 animate-pulse" data-id="element-127"></div>
        <div className="absolute top-1/2 right-1/4 w-48 h-48 bg-[var(--brand-gold)] rounded-full mix-blend-screen filter blur-[120px] opacity-20 animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-128"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-129">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white uppercase tracking-wide mb-6 max-w-5xl" data-id="element-130">
          Transform Your Outdoor Space After Dark
        </h1>

        <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl leading-relaxed" data-id="element-131">
          Premium outdoor lighting design & installation serving the greater
          Phoenix area. We create stunning, custom lighting solutions that make
          your property shine night after night.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-12 w-full sm:w-auto" data-id="element-132">
          <Button size="lg" className="w-full sm:w-auto bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium text-lg h-14 px-8" data-id="element-133">
            Get a Free Quote
          </Button>
          <Button variant="outline" size="lg" className="w-full sm:w-auto bg-transparent border-white text-white hover:bg-white/10 font-medium text-lg h-14 px-8" data-id="element-134">
            View Our Work
          </Button>
        </div>

        <div className="flex items-center gap-3 text-white text-xl md:text-2xl font-medium" data-id="element-135">
          <Phone className="w-6 h-6 text-[var(--brand-gold)]" data-id="element-136" />
          <a href="tel:480-270-2014" className="hover:text-[var(--brand-gold)] transition-colors" data-id="element-137">
            480-270-2014
          </a>
        </div>
      </div>
    </section>;
}